var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonAddSharp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "ionicon",
    viewBox: "0 0 512 512",
    fill: "#df2d61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106 304v-54h54v-36h-54v-54H70v54H16v36h54v54h36z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 288,
    cy: 144,
    r: 112
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M288 288c-69.42 0-208 42.88-208 128v64h416v-64c0-85.12-138.58-128-208-128z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonAddSharp);
export default __webpack_public_path__ + "static/media/person-add-sharp.f11154315dae61e037f30eab8bda37fe.svg";
export { ForwardRef as ReactComponent };